import { useGetStatusOfGenerationQuery } from "../../../redux/services/apiHome";
import Loader from "../../../components/Loader";
import { useSelector } from "react-redux";
import { replaceMonthWithHindi } from "../../../Utils/utils";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";

const StatusOfGeneration = ({ data }) => {
  const { getText } = useLanguageTranslation();

  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: fetchedData = [], isLoading } = useGetStatusOfGenerationQuery({
    query: data,
    lang: languageType,
  });

  const fetchedObject = Object.values(fetchedData)[0] || {};

  const {
    description,
    generation_for_the_month,
    total_generation_during_financial_year,
    april_label,
    financial_year,
    total_generation_from_april,
  } = fetchedObject;

  console.log({ financial_year });

  if (!fetchedData || Object.keys(fetchedData).length === 0) {
    return <div>No data available.</div>;
  }

  const maybeTranslate = (text) => {
    if (!text) return "N/A";
    return languageType === "hi" ? replaceMonthWithHindi(text) : text;
  };
  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="title-sec">
        <h4>{getText("Status of Generation", "उत्पादन की स्थिति")}</h4>
      </div>
      <div className="table-responsive">
        <table className="table table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>{getText("S.No.", "क्र. सं.")}</th>
              <th>{getText("Description", "विवरण")}</th>
              <th>{getText("Generation (MU)", "उत्त्पादन (एमयू)")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-key="S.No">1</td>
              <td data-key="Description">{maybeTranslate(description)}</td>
              <td data-key="Generation (MU)">
                {generation_for_the_month}&nbsp;
                <strong>{getText("MU", "एमयू")}</strong>
              </td>
            </tr>
            <tr>
              <td data-key="S.No">2</td>
              <td data-key="Description">{maybeTranslate(april_label)}</td>
              <td data-key="Generation (MU)">
                {total_generation_from_april}&nbsp;
                <strong>{getText("MU", "एमयू")}</strong>
              </td>
            </tr>
            <tr>
              <td data-key="S.No">3</td>
              <td data-key="Description">{maybeTranslate(financial_year)}</td>
              <td data-key="Generation (MU)">
                {total_generation_during_financial_year}&nbsp;
                <strong>{getText("MU", "एमयू")}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default StatusOfGeneration;
